import React from 'react';
import { PageLayout } from '@/shared/layout';
import { useConstructionSchedules } from './hooks/useConstructionSchedules';
import { useCompany } from '@/modules/company/hooks/useCompany';
import { ScheduleKPIBoard } from './components/ScheduleKPIBoard';
import { ScheduleToolbar } from './components/ScheduleToolbar';
import { ScheduleTable } from './components/ScheduleTable';
import { Card } from '@/components/ui';

export default function ScheduleListPage() {
  const { company } = useCompany();
  const { 
    schedules, 
    stats, 
    isLoading, 
    filters, 
    setFilters 
  } = useConstructionSchedules(company?.id || '');

  return (
    <PageLayout
      title="Lịch trình thi công"
      description="Quản lý tiến độ, kế hoạch triển khai và điều phối tổ đội theo thời gian"
      breadcrumbs={[{ label: 'Thi công' }, { label: 'Lịch trình' }]}
    >
      <ScheduleKPIBoard stats={stats} isLoading={isLoading} />
      
      <ScheduleToolbar 
        filters={filters} 
        onFilterChange={setFilters} 
        onAdd={() => {}} 
      />

      <Card className="overflow-hidden border-slate-100">
        <ScheduleTable data={schedules} isLoading={isLoading} />
      </Card>
    </PageLayout>
  );
}
